"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedCardDetailList = instanceOfPaginatedCardDetailList;
exports.PaginatedCardDetailListFromJSON = PaginatedCardDetailListFromJSON;
exports.PaginatedCardDetailListFromJSONTyped = PaginatedCardDetailListFromJSONTyped;
exports.PaginatedCardDetailListToJSON = PaginatedCardDetailListToJSON;
exports.PaginatedCardDetailListToJSONTyped = PaginatedCardDetailListToJSONTyped;
const cardDetail_1 = require("./cardDetail");
/**
 * Check if a given object implements the PaginatedCardDetailList interface.
 */
function instanceOfPaginatedCardDetailList(value) {
    if (!('count' in value) || value['count'] === undefined)
        return false;
    if (!('next' in value) || value['next'] === undefined)
        return false;
    if (!('previous' in value) || value['previous'] === undefined)
        return false;
    if (!('results' in value) || value['results'] === undefined)
        return false;
    return true;
}
function PaginatedCardDetailListFromJSON(json) {
    return PaginatedCardDetailListFromJSONTyped(json, false);
}
function PaginatedCardDetailListFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'],
        'next': json['next'],
        'previous': json['previous'],
        'results': (json['results'].map(cardDetail_1.CardDetailFromJSON)),
    };
}
function PaginatedCardDetailListToJSON(json) {
    return PaginatedCardDetailListToJSONTyped(json, false);
}
function PaginatedCardDetailListToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': (value['results'].map(cardDetail_1.CardDetailToJSON)),
    };
}
//# sourceMappingURL=paginatedCardDetailList.js.map